import React, { useEffect, useState } from "react"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { Header } from "../../common/header/Header"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { IMG } from "../../common/CONST"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { useNavigate, useParams } from "react-router-dom"
import { IOrderDto } from "../../../types/order/IOrderDto"
import { download, getFormattedDate, round2Digits, spacedNum } from "../../common/CommonHelper"
import { CommonInput } from "../../common/element/fields/CommonInput"
import { IErrorModel } from "../../../types/error/IErrorModel"
import { ModalConfirm } from "../../common/element/ModalConfirm"
import { IB64File } from "../../../types/IB64File"
import { CommonFileList } from "../../common/element/fields/CommonFileList"
import { MenuClient } from "../MenuClient"
import { IFullCompanyDto } from "../../../types/company/IFullCompanyDto"
import Button from "@/ui/components/Button"
import { ORDER_ROUTE } from "@/routes"
import { BaseSettings } from "@/components/admin/settings/types"

export const OrderClientPaid = () => {
  const navigate = useNavigate()
  const params = useParams()

  const [message, setMessage] = useState<IModalMessage | null>(null)
  const [company, setCompany] = useState<IFullCompanyDto>()
  const [errors] = useState<IErrorModel>()
  const [order, setOrder] = useState<IOrderDto>()
  const [calculatedUsd, setCalculatedUsd] = useState<number | undefined>(Number(order?.amountUsd) / 100)
  const [rate, setRate] = useState(order?.xRate)
  const [sending, setSending] = useState(false)
  const [slipInvFiles, setSlipInvFiles] = useState<IB64File[]>([])
  const [confirmInquiryMsg, setConfirmInquiryMsg] = useState<IModalMessage>()
  const [confirmSwiftMsg, setConfirmSwiftMsg] = useState<IModalMessage>()
  const [baseSettings, setBaseSettings] = useState<BaseSettings>()

  useEffect(() => {
    TrinityAPI.getOrder(Number(params.id), response => {
      if (response.status === 200) {
        setOrder(response.data)
      } else {
        setMessage({ title: "Ошибка!", text: `Ошибка при загрузке ордера: ${response.data.message}` })
      }
    })

    TrinityAPI.getBaseSettings().then(response => {
      setBaseSettings(response.data)
    })
  }, [])

  useEffect(() => {
    if (order && order.userId) {
      const files = new Array<IB64File>()
      if (order.agentInvoice) {
        files.push(order.agentInvoice)
      }
      if (order.slip) {
        files.push(order.slip)
      }
      setSlipInvFiles(files)

      setRate(order.xRate)
      setCalculatedUsd(Number(order.amountUsd) / 100)
    }
    if (order?.companyId) {
      TrinityAPI.getCompany(order.companyId, response => {
        if (response.status === 200) {
          setCompany(response.data)
        }
      })
    }
  }, [order])

  useEffect(() => {
    if (rate) {
      const calculated = round2Digits(Number(order?.invoiceAmount) / 100 / Number(rate))
      setCalculatedUsd(calculated)
      setOrder({ ...order, xRate: rate, amountUsd: Math.round(calculated * 100).toString() })
    } else {
      setCalculatedUsd(undefined)
      setOrder({ ...order, xRate: "", amountUsd: undefined })
    }
  }, [rate])

  const submitInquiry = (id: number) => {
    if (sending) return
    setSending(true)
    TrinityAPI.requestInquiry(id, response => {
      if (response.status === 200) {
        window.location.reload()
      } else {
        setMessage({
          title: "Ошибка!",
          text: `Произошла ошибка при отправке запроса на расследование: ${response.data.message}`
        })
        setSending(false)
      }
    })
  }

  const submitSwift = (id: number) => {
    if (sending) return
    setSending(true)
    TrinityAPI.requestSwift(id, response => {
      if (response.status === 200) {
        window.location.reload()
      } else {
        setMessage({
          title: "Ошибка!",
          text: `Произошла ошибка при отправке запроса на SWIFT: ${response.data.message}`
        })
        setSending(false)
      }
    })
  }

  const confirmInquiry = (id: number | undefined) => {
    if (id) submitInquiry(id)
  }

  const confirmSwift = (id: number | undefined) => {
    if (id) submitSwift(id)
  }

  return (
    <>
      <ModalConfirm message={confirmInquiryMsg} setMessage={setConfirmInquiryMsg} />
      <ModalConfirm message={confirmSwiftMsg} setMessage={setConfirmSwiftMsg} />
      <ModalPopUp message={message} close={() => setMessage(null)} error={errors} />
      <MenuClient active={"order"} />
      <main className="main-container" id="scrollable">
        <Header />
        <div className="container" style={{ maxWidth: "1600px" }}>
          <h3 className="ui-heading">Ордер №{order?.id}</h3>
          <div className="container-pop-up">
            <ul className="form-left">
              <li className="form-block-popup">
                <h4 className="heading-chapter">Инвойс</h4>
                <div className="flex-row-10 flex-wrap-mobile">
                  <fieldset>
                    <legend>Дата</legend>
                    <p className="text-form">{getFormattedDate(order?.invoiceDate || "")}</p>
                  </fieldset>
                  <fieldset>
                    <legend>Номер</legend>
                    <p className="text-form">№{order?.invoiceNumber}</p>
                  </fieldset>
                  <fieldset className="fieldset-fit">
                    <legend>Файл инвойса</legend>
                    <button
                      className="btn download-btn"
                      onClick={() => download(order?.id?.toString(), "ORDER_CLIENT_INVOICE")}
                    >
                      <img src={IMG.download} alt="" />
                      Скачать
                    </button>
                  </fieldset>
                </div>
              </li>
              <li className="form-block-popup">
                <h4 className="heading-chapter">Деньги</h4>
                <div className="flex-row-10">
                  <fieldset>
                    <legend>Сумма</legend>
                    <p className="text-form">{spacedNum(Number(order?.invoiceAmount) / 100 || "")}</p>
                  </fieldset>
                  <fieldset className="fieldset-200">
                    <legend>Валюта</legend>
                    <p className="text-form">{order?.invoiceCurrency}</p>
                  </fieldset>
                </div>
              </li>
              <li className="form-block-popup">
                <h4 className="heading-chapter">Информация о получателе</h4>
                <fieldset>
                  <legend>Контактное лицо</legend>
                  <p className="text-form">{order?.contractorContactName}</p>
                </fieldset>
                <fieldset>
                  <legend>Должность</legend>
                  <p className="text-form">{order?.contractorContactJobTitle}</p>
                </fieldset>
                <div className="flex-row-10">
                  <fieldset>
                    <legend>email</legend>
                    <p className="text-form">{order?.contractorContactEmail}</p>
                  </fieldset>
                  <fieldset>
                    <legend>Телефон</legend>
                    <p className="text-form">{order?.contractorContactPhone}</p>
                  </fieldset>
                </div>
              </li>
              <li className="form-block-popup">
                <h4 className="heading-chapter">Получатель валютных средств</h4>
                <fieldset>
                  <legend>Полное название</legend>
                  <p className="text-form">{order?.contractorName}</p>
                </fieldset>
                <fieldset>
                  <legend>Страна</legend>
                  <p className="text-form">{order?.contractorCountry?.name}</p>
                </fieldset>
                <fieldset>
                  <legend>Адрес</legend>
                  <p className="text-form">{order?.contractorAddress}</p>
                </fieldset>
              </li>
              <li className="form-block-popup">
                <h4 className="heading-chapter">Счет</h4>
                <fieldset>
                  <legend>Банк</legend>
                  <p className="text-form">{order?.contractorBankName}</p>
                </fieldset>
                <div className="flex-row-10">
                  <fieldset>
                    <legend>IBAN</legend>
                    <p className="text-form">{order?.contractorAccountNumber}</p>
                  </fieldset>
                  <fieldset>
                    <legend>SWIFT</legend>
                    <p className="text-form">{order?.contractorSwift}</p>
                  </fieldset>
                </div>
              </li>
            </ul>
            <ul className="right-form">
              <li className="form-block-popup">
                <h4 className="heading-chapter">Подтверждающие документы</h4>
                <div className="flex-row-10">
                  <fieldset>
                    <div className="flex-row-10">
                      <button
                        className="btn download-btn"
                        onClick={() => download(order?.id?.toString(), "ORDER_SLIP")}
                      >
                        <img src={IMG.download} alt="" />
                        slip
                      </button>
                      <button
                        className="btn download-btn"
                        onClick={() => download(order?.id?.toString(), "ORDER_AGENT_INVOICE")}
                      >
                        <img src={IMG.download} alt="" />
                        Агентский инвойс
                      </button>
                    </div>
                  </fieldset>
                </div>
                <CommonFileList files={slipInvFiles} />
              </li>
              <li
                className="form-block-popup"
                style={order?.status !== "NEW" ? { pointerEvents: "none", opacity: 0.7 } : {}}
              >
                <h4 className="heading-chapter">Фиксация курса</h4>
                <CommonInput
                  typeName={"number"}
                  label={`Курс USD/${order?.invoiceCurrency} на момент оплаты`}
                  placeholder={"Введите курс"}
                  name={"xRate"}
                  value={rate}
                  errorModel={errors}
                  _callback={v => setRate(v)}
                />
              </li>
              <div className="form-block-popup">
                <h4 className="heading-chapter">Расчет</h4>
                <div className="flex-row-10">
                  <fieldset>
                    <legend className="legend-no-padding">Сумма в {order?.invoiceCurrency}</legend>
                    <p className="text-form-final">{spacedNum(Number(order?.invoiceAmount) / 100)}</p>
                  </fieldset>
                  <fieldset>
                    <legend className="legend-no-padding">Сумма в USD</legend>
                    <p className="text-form-final">{calculatedUsd ? spacedNum(calculatedUsd) : "-"}</p>
                  </fieldset>
                </div>
                {order?.refundAmount && (
                  <div className="flex-row-10">
                    <fieldset>
                      <legend className="legend-no-padding">Сумма возврата</legend>
                      <p className="text-form-final">{spacedNum(round2Digits(Number(order.refundAmount) / 100))}</p>
                    </fieldset>
                  </div>
                )}
              </div>

              {company && (
                <div className="form-block-popup">
                  <h4 className="heading-chapter">Компания плательщик</h4>
                  <div className="flex-column-5">
                    <p className="money-summ">{company.name}</p>
                  </div>
                </div>
              )}

              {order?.status !== "REFUNDED" && order?.status !== "NEW" ? (
                <>
                  {order?.inquiryReportPath ? (
                    <li className="form-block-popup">
                      <h4 className="heading-chapter">Расследование</h4>
                      <p className="text-block">Загруженный файл расследования</p>
                      <button
                        className="btn download-btn"
                        onClick={() => download(order?.id?.toString(), "ORDER_INQUIRY")}
                      >
                        <img src={IMG.download} alt="" />
                        Скачать
                      </button>
                    </li>
                  ) : (
                    <li className="form-block-popup">
                      <h4 className="heading-chapter">Расследование</h4>
                      {order?.status === "INQUIRY" || order?.status === "INQ_SWIFT" ? (
                        <>
                          <p className="text-block">Расследование запрошено</p>
                        </>
                      ) : (
                        <>
                          <p className="text-block">
                            Вы можете заказать расследование, стоимость услуги{" "}
                            {order?.inquiryAmount || baseSettings?.inquiryAmount} USD
                          </p>
                          <div className="flex-row-justify">
                            <div className="flex-row-24">
                              <Button
                                onClick={() => {
                                  setConfirmInquiryMsg({
                                    title: "Подтверждаете запрос расследования?",
                                    text: `После подтверждения с вашего счета будет списано ${
                                      order?.inquiryAmount || baseSettings?.inquiryAmount
                                    } USD за услугу`,
                                    callbackValue: order?.id,
                                    _callback: confirmInquiry
                                  })
                                }}
                              >
                                Запрос расследования
                              </Button>
                            </div>
                          </div>
                        </>
                      )}
                    </li>
                  )}

                  {order?.swiftReportPath ? (
                    <li className="form-block-popup">
                      <h4 className="heading-chapter">SWIFT</h4>
                      <p className="text-block">Загруженный файл SWIFT</p>
                      <button
                        className="btn download-btn"
                        onClick={() => download(order?.id?.toString(), "ORDER_SWIFT")}
                      >
                        <img src={IMG.download} alt="" />
                        Скачать
                      </button>
                    </li>
                  ) : (
                    <li className="form-block-popup">
                      <h4 className="heading-chapter">SWIFT</h4>
                      {order?.status === "SWIFT" || order?.status === "INQ_SWIFT" ? (
                        <>
                          <p className="text-block">SWIFT запрошен</p>
                        </>
                      ) : (
                        <>
                          <p className="text-block">
                            Вы можете заказать SWIFT, стоимость услуги {order?.swiftAmount || baseSettings?.swiftAmount}{" "}
                            USD
                          </p>
                          <div className="flex-row-justify">
                            <div className="flex-row-24">
                              <Button
                                onClick={() => {
                                  setConfirmSwiftMsg({
                                    title: "Подтверждаете запрос SWIFT?",
                                    text: `После подтверждения с вашего счета будет списано ${
                                      order?.swiftAmount || baseSettings?.swiftAmount
                                    } USD за услугу`,
                                    callbackValue: order?.id,
                                    _callback: confirmSwift
                                  })
                                }}
                              >
                                Запрос SWIFT
                              </Button>
                            </div>
                          </div>
                        </>
                      )}
                    </li>
                  )}
                </>
              ) : (
                <></>
              )}
            </ul>
            <div className="flex-row-10">
              <Button variant="grey" onClick={() => navigate(ORDER_ROUTE)}>
                Назад
              </Button>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}
